import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { router } from "./router";
import { AppProviders } from "./providers/app-providers";
import { initObservability } from "./platform/observability";

import "./app.css";

// Wire error reporting before anything else so early failures (including
// the missing-root throw below) are captured. No-op unless the DSN is set.
initObservability();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root is missing from index.html.");
}

async function bootstrap(): Promise<void> {
  if (import.meta.env.DEV && import.meta.env.VITE_USE_MSW !== "false") {
    const { startMockServiceWorker } = await import("@vidario/api-client/mock/browser");
    await startMockServiceWorker({ onUnhandledRequest: "bypass" });
  }

  createRoot(container!).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}

void bootstrap();
